import React, { useState, useEffect } from "react";
import { DivTag } from "../../../Components/Tags/Tags";
import Header from "../../../Components/Header";
import Seo from "../../../Components/SeoComponent/Seo";
import { HeadTag, InputField } from "../../../Components/Tags/Tags";
import { showSuccessToast, showErrorToast } from "../../../utils/toastUtils";
import GaugeChart from "react-gauge-chart";
import {
  checkCrifCreditScore,
  V2VerifyMobile,
} from "../../../Services/EquifaxCScore/highmark";
import CrifScoreReportModal from "./CrifScoreReport";
import html2pdf from "html2pdf.js";
import { CrifCreditScoredata, EV2MobileVerify } from "./data";
import Loader from "../../../Loader";
import { fetchProfile } from "../../../Services/profile/profileservice";
import { FaHandPointLeft } from "react-icons/fa";
import { Link } from "react-router-dom";

const CrifCreditScore = () => {
  const [cusName, setCusName] = useState();
  const [mobile, setMobile] = useState("");
  const [panNo, setPanNo] = useState("");
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  // const [creditScore, setCreditScore] = useState(CrifCreditScoredata?.data?.credit_report?.SCORES?.SCORE?.['SCORE-VALUE']);
  const [creditScore, setCreditScore] = useState(0);
  const [isModalOpen, setModalOpen] = useState(false);
  const [docType, setDocType] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [profileData, setProfileData] = useState([]);
  const [Equifaxv2Report, setEquifaxv2Report] = useState({
    "status": {
        "code": 200,
        "type": "success",
        "message": "Report Generated Successfully"
    },
    "message": "Report Generated Successfully",
    "data": {
        "report_data": {
            "HEADER-SEGMENT": {
                "DATE-OF-REQUEST": "05-06-2026",
                "DATE-OF-ISSUE": "05-06-2026",
                "REPORT-ID": "CCR260515CR081828679",
                "BATCH-ID": "4595575211260515",
                "STATUS": "SUCCESS"
            },
            "REQUEST-DATA": {
                "APPLICANT-SEGMENT": {
                    "FIRST-NAME": "RAM",
                    "MIDDLE-NAME": "",
                    "LAST-NAME": "BHANDRI",
                    "GENDER": "",
                    "APPLICANT-ID": "",
                    "DOB": {
                        "DOB-DT": "30-05-1960",
                        "AGE": "",
                        "AGE-AS-ON": ""
                    },
                    "IDS": [
                        {
                            "TYPE": "ID07",
                            "VALUE": "ARSPB2789E"
                        }
                    ],
                    "ADDRESSES": [
                        {
                            "TYPE": "D08",
                            "ADDRESSTEXT": "RETIRED (INDIAN ARMY) 169 RAJEEV NAGAR TARLI KANDOLI 248001 UK UK  UK Uttarakhand 248001",
                            "CITY": "",
                            "LOCALITY": "",
                            "STATE": "",
                            "PIN": "",
                            "COUNTRY": "India"
                        }
                    ],
                    "PHONES": [
                        {
                            "TYPE": "P01",
                            "VALUE": "8191817766"
                        }
                    ],
                    "EMAILS": [
                        {
                            "EMAIL": "ram.singh.bhandari@gmail.com"
                        }
                    ],
                    "ACCOUNT-NUMBER": ""
                },
                "APPLICATION-SEGMENT": {
                    "INQUIRY-UNIQUE-REF-NO": "",
                    "CREDIT-RPT-ID": "",
                    "CREDIT-RPT-TRN-DT-TM": "",
                    "CREDIT-INQ-PURPS-TYPE": "",
                    "CREDIT-INQUIRY-STAGE": "",
                    "CLIENT-CONTRIBUTOR-ID": "",
                    "BRANCH-ID": "",
                    "APPLICATION-ID": "",
                    "ACNT-OPEN-DT": "",
                    "LOAN-AMT": "",
                    "LTV": "",
                    "TERM": "",
                    "LOAN-TYPE": ""
                }
            },
            "REPORT-DATA": {
                "STANDARD-DATA": {
                    "DEMOGS": {
                        "VARIATIONS": [
                            {
                                "TYPE": "NAME-VARIATIONS",
                                "VARIATION": [
                                    {
                                        "VALUE": "RAM SINGH",
                                        "REPORTED-DT": "31-07-2015",
                                        "FIRST-REPORTED-DT": "31-07-2015",
                                        "LOAN-TYPE-ASSOC": "",
                                        "SOURCE-INDICATOR": ""
                                    },
                                    {
                                        "VALUE": "RAM SINGH BHANDRI",
                                        "REPORTED-DT": "30-04-2026",
                                        "FIRST-REPORTED-DT": "30-04-2026",
                                        "LOAN-TYPE-ASSOC": "",
                                        "SOURCE-INDICATOR": ""
                                    },
                                    {
                                        "VALUE": "RAM SINGH BHANDARI",
                                        "REPORTED-DT": "31-12-2016",
                                        "FIRST-REPORTED-DT": "31-12-2016",
                                        "LOAN-TYPE-ASSOC": "",
                                        "SOURCE-INDICATOR": ""
                                    }
                                ]
                            },
                            {
                                "TYPE": "ADDRESS-VARIATIONS",
                                "VARIATION": [
                                    {
                                        "VALUE": "S\/O: NARAYAN SINGH BHANDARI 169 RAJEEV NAGAR TARLI KANDOLI DEHRADUN DEHRADUN 248001 UK",
                                        "REPORTED-DT": "30-04-2022",
                                        "FIRST-REPORTED-DT": "30-04-2022",
                                        "LOAN-TYPE-ASSOC": "",
                                        "SOURCE-INDICATOR": ""
                                    },
                                    {
                                        "VALUE": "DEHRADUN                                 DEHRADUN                                 248001     UK",
                                        "REPORTED-DT": "31-12-2008",
                                        "FIRST-REPORTED-DT": "31-12-2008",
                                        "LOAN-TYPE-ASSOC": "",
                                        "SOURCE-INDICATOR": ""
                                    },
                                    {
                                        "VALUE": "RETIRED (INDIAN ARMY) 169 RAJEEV NAGAR TARLI KANDOLI 248001 UK",
                                        "REPORTED-DT": "30-04-2026",
                                        "FIRST-REPORTED-DT": "30-04-2026",
                                        "LOAN-TYPE-ASSOC": "",
                                        "SOURCE-INDICATOR": ""
                                    },
                                    {
                                        "VALUE": "306 TARLI KANDOLI RAJIVNAGAR DEHRADUN DEHRADUN 248003 UK",
                                        "REPORTED-DT": "31-07-2015",
                                        "FIRST-REPORTED-DT": "31-07-2015",
                                        "LOAN-TYPE-ASSOC": "",
                                        "SOURCE-INDICATOR": ""
                                    },
                                    {
                                        "VALUE": "11 GARHWAL RAIFILS ,   GRRC LANSDONE ,  ,  248001 UK",
                                        "REPORTED-DT": "31-07-2023",
                                        "FIRST-REPORTED-DT": "31-07-2023",
                                        "LOAN-TYPE-ASSOC": "",
                                        "SOURCE-INDICATOR": ""
                                    },
                                    {
                                        "VALUE": "DEHRADUN                                 DEHRADUN                                 248001     OR",
                                        "REPORTED-DT": "30-06-2008",
                                        "FIRST-REPORTED-DT": "30-06-2008",
                                        "LOAN-TYPE-ASSOC": "",
                                        "SOURCE-INDICATOR": ""
                                    },
                                    {
                                        "VALUE": "169 RAJEEV NAGAR TARLI KANDOLI (DEHRADUN) UTTARAKHAND DEHRADUN 249145 UK",
                                        "REPORTED-DT": "31-12-2016",
                                        "FIRST-REPORTED-DT": "31-12-2016",
                                        "LOAN-TYPE-ASSOC": "",
                                        "SOURCE-INDICATOR": ""
                                    },
                                    {
                                        "VALUE": "169 ,  RAJEEV NAGAR TARLI ,  KONDOLI  ,  ,    ,  248001 UK",
                                        "REPORTED-DT": "31-08-2023",
                                        "FIRST-REPORTED-DT": "31-08-2023",
                                        "LOAN-TYPE-ASSOC": "",
                                        "SOURCE-INDICATOR": ""
                                    },
                                    {
                                        "VALUE": "169 RAJEEV NAGAR TARLI KANDOLI RAJPUR ROAD 248001 UK",
                                        "REPORTED-DT": "30-04-2026",
                                        "FIRST-REPORTED-DT": "30-04-2026",
                                        "LOAN-TYPE-ASSOC": "",
                                        "SOURCE-INDICATOR": ""
                                    },
                                    {
                                        "VALUE": "169 JAEEV NAGAR KANDOLI 248001 UK",
                                        "REPORTED-DT": "31-03-2026",
                                        "FIRST-REPORTED-DT": "31-03-2026",
                                        "LOAN-TYPE-ASSOC": "",
                                        "SOURCE-INDICATOR": ""
                                    },
                                    {
                                        "VALUE": "DEHRADUN                                 DEHRADUN                                 DEHRADUN                                 248003     UK",
                                        "REPORTED-DT": "31-12-2010",
                                        "FIRST-REPORTED-DT": "31-12-2010",
                                        "LOAN-TYPE-ASSOC": "",
                                        "SOURCE-INDICATOR": ""
                                    },
                                    {
                                        "VALUE": "169 RAJEEV NAGAR KANDOLI TARLI KANDOLI 248001 UK",
                                        "REPORTED-DT": "30-04-2026",
                                        "FIRST-REPORTED-DT": "30-04-2026",
                                        "LOAN-TYPE-ASSOC": "",
                                        "SOURCE-INDICATOR": ""
                                    }
                                ]
                            },
                            {
                                "TYPE": "PAN-VARIATIONS",
                                "VARIATION": [
                                    {
                                        "VALUE": "ARSPB2789E",
                                        "REPORTED-DATE": "30-09-2024"
                                    }
                                ]
                            },
                            {
                                "TYPE": "DOB-VARIATIONS",
                                "VARIATION": [
                                    {
                                        "VALUE": "30-05-1960",
                                        "REPORTED-DT": "31-07-2018",
                                        "FIRST-REPORTED-DT": "31-07-2018",
                                        "LOAN-TYPE-ASSOC": "",
                                        "SOURCE-INDICATOR": ""
                                    },
                                    {
                                        "VALUE": "15-10-1965",
                                        "REPORTED-DT": "30-09-2009",
                                        "FIRST-REPORTED-DT": "30-09-2009",
                                        "LOAN-TYPE-ASSOC": "",
                                        "SOURCE-INDICATOR": ""
                                    }
                                ]
                            },
                            {
                                "TYPE": "PHONE-VARIATIONS",
                                "VARIATION": [
                                    {
                                        "VALUE": "8191817766",
                                        "REPORTED-DT": "31-12-2016",
                                        "FIRST-REPORTED-DT": "31-12-2016",
                                        "LOAN-TYPE-ASSOC": "",
                                        "SOURCE-INDICATOR": ""
                                    },
                                    {
                                        "VALUE": "8958994992",
                                        "REPORTED-DT": "31-08-2023",
                                        "FIRST-REPORTED-DT": "31-08-2023",
                                        "LOAN-TYPE-ASSOC": "",
                                        "SOURCE-INDICATOR": ""
                                    },
                                    {
                                        "VALUE": "9897428337",
                                        "REPORTED-DT": "30-04-2022",
                                        "FIRST-REPORTED-DT": "30-04-2022",
                                        "LOAN-TYPE-ASSOC": "",
                                        "SOURCE-INDICATOR": ""
                                    }
                                ]
                            }
                        ]
                    },
                    "EMPLOYMENT-DETAILS": [
                        {
                            "ACCT-TYPE": "Auto Loan (Personal)",
                            "DATE-REPORTED": "30-04-2026",
                            "OCCUPATION": "SALARIED"
                        }
                    ],
                    "TRADELINES": [
                        {
                            "ACCT-NUMBER": "MFUKMFLONS000005019585",
                            "CREDIT-GRANTOR-GROUP": "",
                            "CREDIT-GRANTOR-TYPE": "",
                            "ACCT-TYPE": "Two-Wheeler Loan",
                            "OWNERSHIP-IND": "Individual",
                            "ACCOUNT-STATUS": "Closed",
                            "DISBURSED-AMT": "40,000",
                            "DISBURSED-DT": "21-03-2018",
                            "INSTALLMENT-AMT": "",
                            "OVERDUE-AMT": "0",
                            "WRITE-OFF-AMT": "0",
                            "PRINCIPAL-WRITE-OFF-AMT": "",
                            "SETTLEMENT-AMT": "",
                            "CURRENT-BAL": "0",
                            "MATCHED-TYPE": "PRIMARY",
                            "LINKED-ACCOUNTS": [],
                            "SECURITY-DETAILS": [],
                            "SECURITY-STATUS": "Secured",
                            "ACCOUNT-REMARKS": "",
                            "ACCT-IN-DISPUTE": "",
                            "SUIT-FILED-WILFUL-DEFAULT-STATUS": "",
                            "WRITTEN-OFF-SETTLED-STATUS": "",
                            "WRITE-OFF-DT": "",
                            "SUIT-FILED-DT": "",
                            "LAST-PAID-AMOUNT": "",
                            "OBLIGATION": "",
                            "ORIGINAL-TERM": "0",
                            "TERM-TO-MATURITY": "0",
                            "ACTUAL-PAYMENT": "",
                            "REPAYMENT-TENURE": "0",
                            "INTEREST-RATE": "0.0",
                            "CREDIT-LIMIT": "",
                            "CASH-LIMIT": "",
                            "OCCUPATION": "",
                            "INCOME-FREQUENCY": "",
                            "INCOME-AMOUNT": "",
                            "CREDIT-GRANTOR": "MANAPPURAM FINANCE LIMITED",
                            "REPORTED-DT": "31-08-2023",
                            "LAST-PAYMENT-DT": "30-04-2019",
                            "CLOSED-DT": "30-04-2019",
                            "HISTORY": [
                                {
                                    "NAME": "COMBINED-PAYMENT-HISTORY",
                                    "DATES": "Apr:2019|Mar:2019|Feb:2019|Jan:2019|Dec:2018|Nov:2018|Oct:2018|Sep:2018|Aug:2018|Jul:2018|Jun:2018|May:2018|Apr:2018|",
                                    "VALUES": "XXX\/XXX|XXX\/XXX|XXX\/XXX|XXX\/XXX|XXX\/XXX|XXX\/XXX|XXX\/XXX|XXX\/XXX|XXX\/XXX|XXX\/XXX|XXX\/XXX|XXX\/XXX|XXX\/XXX|"
                                }
                            ]
                        },
                        {
                            "ACCT-NUMBER": "127112107",
                            "CREDIT-GRANTOR-GROUP": "",
                            "CREDIT-GRANTOR-TYPE": "",
                            "ACCT-TYPE": "Auto Loan (Personal)",
                            "OWNERSHIP-IND": "Joint",
                            "ACCOUNT-STATUS": "Active",
                            "DISBURSED-AMT": "6,07,998",
                            "DISBURSED-DT": "19-03-2022",
                            "INSTALLMENT-AMT": "",
                            "OVERDUE-AMT": "0",
                            "WRITE-OFF-AMT": "0",
                            "PRINCIPAL-WRITE-OFF-AMT": "",
                            "SETTLEMENT-AMT": "",
                            "CURRENT-BAL": "1,30,336",
                            "MATCHED-TYPE": "PRIMARY",
                            "LINKED-ACCOUNTS": [],
                            "SECURITY-DETAILS": [],
                            "SECURITY-STATUS": "Secured",
                            "ACCOUNT-REMARKS": "",
                            "ACCT-IN-DISPUTE": "",
                            "SUIT-FILED-WILFUL-DEFAULT-STATUS": "",
                            "WRITTEN-OFF-SETTLED-STATUS": "",
                            "WRITE-OFF-DT": "",
                            "SUIT-FILED-DT": "",
                            "LAST-PAID-AMOUNT": "12,328",
                            "OBLIGATION": "15130.055993267144",
                            "ORIGINAL-TERM": "0",
                            "TERM-TO-MATURITY": "0",
                            "ACTUAL-PAYMENT": "12,328",
                            "REPAYMENT-TENURE": "0",
                            "INTEREST-RATE": "0.0",
                            "CREDIT-LIMIT": "",
                            "CASH-LIMIT": "",
                            "OCCUPATION": "Salaried",
                            "INCOME-FREQUENCY": "",
                            "INCOME-AMOUNT": "",
                            "CREDIT-GRANTOR": "HDFC BANK LTD",
                            "REPORTED-DT": "30-04-2026",
                            "LAST-PAYMENT-DT": "08-02-2026",
                            "CLOSED-DT": "",
                            "HISTORY": [
                                {
                                    "NAME": "COMBINED-PAYMENT-HISTORY",
                                    "DATES": "Apr:2026|Mar:2026|Feb:2026|Jan:2026|Dec:2025|Nov:2025|Oct:2025|Sep:2025|Aug:2025|Jul:2025|Jun:2025|May:2025|Apr:2025|Mar:2025|Feb:2025|Jan:2025|Dec:2024|Nov:2024|Oct:2024|Sep:2024|Aug:2024|Jul:2024|Jun:2024|May:2024|Apr:2024|Mar:2024|Feb:2024|Jan:2024|Dec:2023|Nov:2023|Oct:2023|Sep:2023|Aug:2023|Jul:2023|Jun:2023|May:2023|",
                                    "VALUES": "000\/XXX|000\/XXX|000\/XXX|000\/STD|000\/STD|000\/STD|000\/STD|000\/STD|000\/STD|000\/STD|000\/STD|000\/STD|000\/STD|000\/STD|000\/STD|000\/STD|000\/STD|000\/STD|000\/STD|000\/STD|000\/STD|000\/STD|000\/STD|000\/STD|000\/STD|000\/STD|000\/STD|000\/STD|000\/STD|000\/STD|000\/STD|000\/STD|000\/STD|000\/STD|000\/STD|000\/STD|"
                                }
                            ]
                        },
                        {
                            "ACCT-NUMBER": "00000036518184846",
                            "CREDIT-GRANTOR-GROUP": "",
                            "CREDIT-GRANTOR-TYPE": "",
                            "ACCT-TYPE": "Personal Loan",
                            "OWNERSHIP-IND": "Individual",
                            "ACCOUNT-STATUS": "Closed",
                            "DISBURSED-AMT": "3,00,000",
                            "DISBURSED-DT": "06-02-2017",
                            "INSTALLMENT-AMT": "6,742\/Monthly\/Monthly",
                            "OVERDUE-AMT": "",
                            "WRITE-OFF-AMT": "0",
                            "PRINCIPAL-WRITE-OFF-AMT": "0",
                            "SETTLEMENT-AMT": "",
                            "CURRENT-BAL": "0",
                            "MATCHED-TYPE": "PRIMARY",
                            "LINKED-ACCOUNTS": [],
                            "SECURITY-DETAILS": [],
                            "SECURITY-STATUS": "Un-Secured",
                            "ACCOUNT-REMARKS": "",
                            "ACCT-IN-DISPUTE": "",
                            "SUIT-FILED-WILFUL-DEFAULT-STATUS": "",
                            "WRITTEN-OFF-SETTLED-STATUS": "",
                            "WRITE-OFF-DT": "",
                            "SUIT-FILED-DT": "",
                            "LAST-PAID-AMOUNT": "",
                            "OBLIGATION": "",
                            "ORIGINAL-TERM": "0",
                            "TERM-TO-MATURITY": "0",
                            "ACTUAL-PAYMENT": "",
                            "REPAYMENT-TENURE": "70",
                            "INTEREST-RATE": "12.0",
                            "CREDIT-LIMIT": "",
                            "CASH-LIMIT": "",
                            "OCCUPATION": "",
                            "INCOME-FREQUENCY": "",
                            "INCOME-AMOUNT": "",
                            "CREDIT-GRANTOR": "STATE BANK OF INDIA",
                            "REPORTED-DT": "30-04-2022",
                            "LAST-PAYMENT-DT": "",
                            "CLOSED-DT": "28-04-2022",
                            "HISTORY": [
                                {
                                    "NAME": "COMBINED-PAYMENT-HISTORY",
                                    "DATES": "Apr:2022|Mar:2022|Feb:2022|Jan:2022|Dec:2021|Nov:2021|Oct:2021|Sep:2021|Aug:2021|Jul:2021|Jun:2021|May:2021|Apr:2021|Mar:2021|Feb:2021|Jan:2021|Dec:2020|Nov:2020|Oct:2020|Sep:2020|Aug:2020|Jul:2020|Jun:2020|May:2020|Apr:2020|Mar:2020|Feb:2020|Jan:2020|Dec:2019|Nov:2019|Oct:2019|Sep:2019|Aug:2019|Jul:2019|Jun:2019|May:2019|",
                                    "VALUES": "XXX\/STD|XXX\/STD|XXX\/STD|XXX\/STD|XXX\/STD|XXX\/STD|XXX\/STD|XXX\/STD|XXX\/STD|XXX\/STD|XXX\/STD|XXX\/STD|XXX\/STD|XXX\/STD|XXX\/STD|XXX\/STD|XXX\/STD|XXX\/STD|XXX\/STD|XXX\/STD|XXX\/STD|XXX\/STD|XXX\/STD|XXX\/STD|XXX\/STD|XXX\/STD|XXX\/STD|XXX\/STD|XXX\/STD|XXX\/STD|XXX\/STD|XXX\/STD|XXX\/STD|XXX\/STD|XXX\/STD|XXX\/STD|"
                                }
                            ]
                        },
                        {
                            "ACCT-NUMBER": "00000030331145562",
                            "CREDIT-GRANTOR-GROUP": "",
                            "CREDIT-GRANTOR-TYPE": "",
                            "ACCT-TYPE": "Personal Loan",
                            "OWNERSHIP-IND": "Individual",
                            "ACCOUNT-STATUS": "Closed",
                            "DISBURSED-AMT": "30,000",
                            "DISBURSED-DT": "19-02-2008",
                            "INSTALLMENT-AMT": "805\/Monthly\/Monthly",
                            "OVERDUE-AMT": "",
                            "WRITE-OFF-AMT": "0",
                            "PRINCIPAL-WRITE-OFF-AMT": "0",
                            "SETTLEMENT-AMT": "",
                            "CURRENT-BAL": "0",
                            "MATCHED-TYPE": "PRIMARY",
                            "LINKED-ACCOUNTS": [],
                            "SECURITY-DETAILS": [],
                            "SECURITY-STATUS": "Un-Secured",
                            "ACCOUNT-REMARKS": "",
                            "ACCT-IN-DISPUTE": "",
                            "SUIT-FILED-WILFUL-DEFAULT-STATUS": "",
                            "WRITTEN-OFF-SETTLED-STATUS": "",
                            "WRITE-OFF-DT": "",
                            "SUIT-FILED-DT": "",
                            "LAST-PAID-AMOUNT": "",
                            "OBLIGATION": "",
                            "ORIGINAL-TERM": "0",
                            "TERM-TO-MATURITY": "0",
                            "ACTUAL-PAYMENT": "",
                            "REPAYMENT-TENURE": "48",
                            "INTEREST-RATE": "14.0",
                            "CREDIT-LIMIT": "",
                            "CASH-LIMIT": "",
                            "OCCUPATION": "",
                            "INCOME-FREQUENCY": "",
                            "INCOME-AMOUNT": "",
                            "CREDIT-GRANTOR": "STATE BANK OF INDIA",
                            "REPORTED-DT": "31-12-2016",
                            "LAST-PAYMENT-DT": "",
                            "CLOSED-DT": "27-02-2011",
                            "HISTORY": [
                                {
                                    "NAME": "COMBINED-PAYMENT-HISTORY",
                                    "DATES": "Feb:2011|Jan:2011|Dec:2010|Nov:2010|Oct:2010|Sep:2010|Aug:2010|Jul:2010|Jun:2010|May:2010|Apr:2010|Mar:2010|Feb:2010|Jan:2010|Dec:2009|Nov:2009|Oct:2009|Sep:2009|Aug:2009|Jul:2009|Jun:2009|May:2009|Apr:2009|Mar:2009|Feb:2009|Jan:2009|Dec:2008|Nov:2008|Oct:2008|Sep:2008|Aug:2008|Jul:2008|Jun:2008|May:2008|Apr:2008|Mar:2008|",
                                    "VALUES": "XXX\/XXX|XXX\/XXX|XXX\/XXX|XXX\/XXX|XXX\/XXX|XXX\/XXX|XXX\/XXX|XXX\/XXX|XXX\/XXX|XXX\/XXX|XXX\/XXX|XXX\/XXX|XXX\/XXX|XXX\/XXX|XXX\/XXX|XXX\/XXX|XXX\/XXX|XXX\/XXX|XXX\/XXX|XXX\/XXX|XXX\/XXX|XXX\/XXX|XXX\/XXX|XXX\/XXX|XXX\/XXX|XXX\/XXX|XXX\/XXX|XXX\/XXX|XXX\/XXX|XXX\/XXX|XXX\/XXX|XXX\/XXX|XXX\/XXX|XXX\/XXX|XXX\/XXX|XXX\/XXX|"
                                }
                            ]
                        },
                        {
                            "ACCT-NUMBER": "00000032983075935",
                            "CREDIT-GRANTOR-GROUP": "",
                            "CREDIT-GRANTOR-TYPE": "",
                            "ACCT-TYPE": "Personal Loan",
                            "OWNERSHIP-IND": "Individual",
                            "ACCOUNT-STATUS": "Closed",
                            "DISBURSED-AMT": "1,00,000",
                            "DISBURSED-DT": "07-05-2013",
                            "INSTALLMENT-AMT": "3,088\/Monthly\/Monthly",
                            "OVERDUE-AMT": "",
                            "WRITE-OFF-AMT": "0",
                            "PRINCIPAL-WRITE-OFF-AMT": "0",
                            "SETTLEMENT-AMT": "",
                            "CURRENT-BAL": "0",
                            "MATCHED-TYPE": "PRIMARY",
                            "LINKED-ACCOUNTS": [],
                            "SECURITY-DETAILS": [],
                            "SECURITY-STATUS": "Un-Secured",
                            "ACCOUNT-REMARKS": "",
                            "ACCT-IN-DISPUTE": "",
                            "SUIT-FILED-WILFUL-DEFAULT-STATUS": "",
                            "WRITTEN-OFF-SETTLED-STATUS": "",
                            "WRITE-OFF-DT": "",
                            "SUIT-FILED-DT": "",
                            "LAST-PAID-AMOUNT": "",
                            "OBLIGATION": "",
                            "ORIGINAL-TERM": "0",
                            "TERM-TO-MATURITY": "0",
                            "ACTUAL-PAYMENT": "",
                            "REPAYMENT-TENURE": "60",
                            "INTEREST-RATE": "14.0",
                            "CREDIT-LIMIT": "",
                            "CASH-LIMIT": "",
                            "OCCUPATION": "",
                            "INCOME-FREQUENCY": "",
                            "INCOME-AMOUNT": "",
                            "CREDIT-GRANTOR": "STATE BANK OF INDIA",
                            "REPORTED-DT": "31-12-2016",
                            "LAST-PAYMENT-DT": "",
                            "CLOSED-DT": "30-11-2016",
                            "HISTORY": [
                                {
                                    "NAME": "COMBINED-PAYMENT-HISTORY",
                                    "DATES": "Nov:2016|Oct:2016|Sep:2016|Aug:2016|Jul:2016|Jun:2016|May:2016|Apr:2016|Mar:2016|Feb:2016|Jan:2016|Dec:2015|Nov:2015|Oct:2015|Sep:2015|Aug:2015|Jul:2015|Jun:2015|May:2015|Apr:2015|Mar:2015|Feb:2015|Jan:2015|Dec:2014|Nov:2014|Oct:2014|Sep:2014|Aug:2014|Jul:2014|Jun:2014|May:2014|Apr:2014|Mar:2014|Feb:2014|Jan:2014|Dec:2013|",
                                    "VALUES": "XXX\/STD|XXX\/STD|XXX\/STD|XXX\/STD|XXX\/STD|XXX\/STD|XXX\/STD|XXX\/STD|XXX\/STD|XXX\/STD|XXX\/STD|XXX\/STD|XXX\/STD|XXX\/STD|XXX\/STD|XXX\/STD|XXX\/STD|XXX\/STD|XXX\/STD|XXX\/STD|XXX\/STD|XXX\/STD|XXX\/STD|XXX\/STD|XXX\/STD|XXX\/STD|XXX\/STD|XXX\/STD|XXX\/STD|XXX\/STD|XXX\/STD|XXX\/STD|XXX\/STD|XXX\/STD|XXX\/STD|XXX\/XXX|"
                                }
                            ]
                        },
                        {
                            "ACCT-NUMBER": "56186462",
                            "CREDIT-GRANTOR-GROUP": "",
                            "CREDIT-GRANTOR-TYPE": "",
                            "ACCT-TYPE": "Auto Loan (Personal)",
                            "OWNERSHIP-IND": "Joint",
                            "ACCOUNT-STATUS": "Active",
                            "DISBURSED-AMT": "3,86,761",
                            "DISBURSED-DT": "04-04-2018",
                            "INSTALLMENT-AMT": "",
                            "OVERDUE-AMT": "0",
                            "WRITE-OFF-AMT": "0",
                            "PRINCIPAL-WRITE-OFF-AMT": "",
                            "SETTLEMENT-AMT": "",
                            "CURRENT-BAL": "0",
                            "MATCHED-TYPE": "PRIMARY",
                            "LINKED-ACCOUNTS": [],
                            "SECURITY-DETAILS": [],
                            "SECURITY-STATUS": "Secured",
                            "ACCOUNT-REMARKS": "",
                            "ACCT-IN-DISPUTE": "",
                            "SUIT-FILED-WILFUL-DEFAULT-STATUS": "",
                            "WRITTEN-OFF-SETTLED-STATUS": "",
                            "WRITE-OFF-DT": "",
                            "SUIT-FILED-DT": "",
                            "LAST-PAID-AMOUNT": "0",
                            "OBLIGATION": "",
                            "ORIGINAL-TERM": "0",
                            "TERM-TO-MATURITY": "0",
                            "ACTUAL-PAYMENT": "0",
                            "REPAYMENT-TENURE": "0",
                            "INTEREST-RATE": "0.0",
                            "CREDIT-LIMIT": "",
                            "CASH-LIMIT": "",
                            "OCCUPATION": "Salaried",
                            "INCOME-FREQUENCY": "",
                            "INCOME-AMOUNT": "",
                            "CREDIT-GRANTOR": "HDFC BANK LTD",
                            "REPORTED-DT": "30-04-2026",
                            "LAST-PAYMENT-DT": "08-11-2025",
                            "CLOSED-DT": "",
                            "HISTORY": [
                                {
                                    "NAME": "COMBINED-PAYMENT-HISTORY",
                                    "DATES": "Apr:2026|Mar:2026|Feb:2026|Jan:2026|Dec:2025|Nov:2025|Oct:2025|Sep:2025|Aug:2025|Jul:2025|Jun:2025|May:2025|Apr:2025|Mar:2025|Feb:2025|Jan:2025|Dec:2024|Nov:2024|Oct:2024|Sep:2024|Aug:2024|Jul:2024|Jun:2024|May:2024|Apr:2024|Mar:2024|Feb:2024|Jan:2024|Dec:2023|Nov:2023|Oct:2023|Sep:2023|Aug:2023|Jul:2023|Jun:2023|May:2023|",
                                    "VALUES": "000\/XXX|000\/XXX|000\/XXX|000\/STD|000\/STD|000\/STD|000\/STD|000\/STD|025\/STD|025\/STD|024\/STD|025\/STD|024\/STD|025\/STD|022\/STD|025\/STD|025\/STD|024\/STD|025\/STD|024\/STD|025\/STD|025\/STD|024\/STD|025\/STD|024\/STD|000\/STD|000\/STD|000\/STD|000\/STD|000\/STD|025\/STD|024\/STD|025\/STD|025\/STD|024\/STD|025\/STD|"
                                }
                            ]
                        },
                        {
                            "ACCT-NUMBER": "00000030050799383",
                            "CREDIT-GRANTOR-GROUP": "",
                            "CREDIT-GRANTOR-TYPE": "",
                            "ACCT-TYPE": "Personal Loan",
                            "OWNERSHIP-IND": "Individual",
                            "ACCOUNT-STATUS": "Closed",
                            "DISBURSED-AMT": "24,000",
                            "DISBURSED-DT": "24-05-2006",
                            "INSTALLMENT-AMT": "617\/Monthly\/Monthly",
                            "OVERDUE-AMT": "",
                            "WRITE-OFF-AMT": "0",
                            "PRINCIPAL-WRITE-OFF-AMT": "0",
                            "SETTLEMENT-AMT": "",
                            "CURRENT-BAL": "0",
                            "MATCHED-TYPE": "PRIMARY",
                            "LINKED-ACCOUNTS": [],
                            "SECURITY-DETAILS": [],
                            "SECURITY-STATUS": "Un-Secured",
                            "ACCOUNT-REMARKS": "",
                            "ACCT-IN-DISPUTE": "",
                            "SUIT-FILED-WILFUL-DEFAULT-STATUS": "",
                            "WRITTEN-OFF-SETTLED-STATUS": "",
                            "WRITE-OFF-DT": "",
                            "SUIT-FILED-DT": "",
                            "LAST-PAID-AMOUNT": "",
                            "OBLIGATION": "",
                            "ORIGINAL-TERM": "0",
                            "TERM-TO-MATURITY": "0",
                            "ACTUAL-PAYMENT": "",
                            "REPAYMENT-TENURE": "48",
                            "INTEREST-RATE": "13.0",
                            "CREDIT-LIMIT": "",
                            "CASH-LIMIT": "",
                            "OCCUPATION": "",
                            "INCOME-FREQUENCY": "",
                            "INCOME-AMOUNT": "",
                            "CREDIT-GRANTOR": "STATE BANK OF INDIA",
                            "REPORTED-DT": "31-12-2016",
                            "LAST-PAYMENT-DT": "",
                            "CLOSED-DT": "19-02-2008",
                            "HISTORY": [
                                {
                                    "NAME": "COMBINED-PAYMENT-HISTORY",
                                    "DATES": "Feb:2008|Jan:2008|Dec:2007|Nov:2007|Oct:2007|Sep:2007|Aug:2007|Jul:2007|Jun:2007|May:2007|Apr:2007|Mar:2007|Feb:2007|Jan:2007|Dec:2006|Nov:2006|Oct:2006|Sep:2006|Aug:2006|Jul:2006|Jun:2006|",
                                    "VALUES": "XXX\/XXX|XXX\/XXX|XXX\/XXX|XXX\/XXX|XXX\/XXX|XXX\/XXX|XXX\/XXX|XXX\/XXX|XXX\/XXX|XXX\/XXX|XXX\/XXX|XXX\/XXX|XXX\/XXX|XXX\/XXX|XXX\/XXX|XXX\/XXX|XXX\/XXX|XXX\/XXX|XXX\/XXX|XXX\/XXX|XXX\/XXX|"
                                }
                            ]
                        }
                    ],
                    "INQUIRY-HISTORY": [
                        {
                            "MEMBER-NAME": "MS MAHASHAKTI FINANCIERS LTD",
                            "PURPOSE": "Personal Loan",
                            "AMOUNT": "10,000",
                            "REMARK": "\u2014",
                            "INQUIRY-DATE": "22-01-2026"
                        },
                        {
                            "MEMBER-NAME": "IDS NIDHI LIMITED",
                            "PURPOSE": "OTHER",
                            "AMOUNT": "5,00,000",
                            "REMARK": "\u2014",
                            "INQUIRY-DATE": "10-02-2025"
                        }
                    ],
                    "SCORE": [
                        {
                            "NAME": "PERFORM CONSUMER 2.2",
                            "VERSION": null,
                            "VALUE": "698",
                            "DESCRIPTION": null,
                            "FACTORS": [
                                {
                                    "TYPE": "SF11",
                                    "DESC": ""
                                },
                                {
                                    "TYPE": "SF04",
                                    "DESC": ""
                                }
                            ]
                        }
                    ]
                },
                "REQUESTED-SERVICES": null,
                "ACCOUNTS-SUMMARY": {
                    "PRIMARY-ACCOUNTS-SUMMARY": {
                        "NUMBER-OF-ACCOUNTS": "7",
                        "ACTIVE-ACCOUNTS": "2",
                        "OVERDUE-ACCOUNTS": "0",
                        "SECURED-ACCOUNTS": "3",
                        "UNSECURED-ACCOUNTS": "4",
                        "UNTAGGED-ACCOUNTS": "0",
                        "TOTAL-CURRENT-BALANCE": "0",
                        "CURRENT-BALANCE-SECURED": "0",
                        "CURRENT-BALANCE-UNSECURED": "0",
                        "TOTAL-SANCTIONED-AMT": "0",
                        "TOTAL-DISBURSED-AMT": "0",
                        "TOTAL-AMT-OVERDUE": "0"
                    },
                    "SECONDARY-ACCOUNTS-SUMMARY": {
                        "NUMBER-OF-ACCOUNTS": "0",
                        "ACTIVE-ACCOUNTS": "0",
                        "OVERDUE-ACCOUNTS": "0",
                        "SECURED-ACCOUNTS": "0.0",
                        "UNSECURED-ACCOUNTS": "0",
                        "UNTAGGED-ACCOUNTS": "0",
                        "TOTAL-CURRENT-BALANCE": "0",
                        "TOTAL-SANCTIONED-AMT": "0",
                        "TOTAL-DISBURSED-AMT": "0",
                        "TOTAL-AMT-OVERDUE": "0"
                    },
                    "DERIVED-ATTRIBUTES": {
                        "INQUIRIES-IN-LAST-SIX-MONTHS": "1",
                        "LENGTH-OF-CREDIT-HISTORY-YEAR": "8",
                        "LENGTH-OF-CREDIT-HISTORY-MONTH": "0",
                        "AVERAGE-ACCOUNT-AGE-YEAR": "3",
                        "AVERAGE-ACCOUNT-AGE-MONTH": "9",
                        "NEW-ACCOUNTS-IN-LAST-SIX-MONTHS": "0",
                        "NEW-DELINQ-ACCOUNT-IN-LAST-SIX-MONTHS": "0"
                    },
                    "MFI-GROUP-ACCOUNTS-SUMMARY": {
                        "NUMBER-OF-ACCOUNTS": "0",
                        "ACTIVE-ACCOUNTS": "0",
                        "OVERDUE-ACCOUNTS": "0",
                        "CLOSED-ACCOUNTS": "0",
                        "NO-OF-OTHER-MFIS": "0",
                        "NO-OF-OWN-MFIS": "0",
                        "TOTAL-OWN-CURRENT-BALANCE": "0.0",
                        "TOTAL-OWN-INSTALLMENT-AMT": "0",
                        "TOTAL-OWN-DISBURSED-AMT": "0.0",
                        "TOTAL-OWN-OVERDUE-AMT": "0.0",
                        "TOTAL-OTHER-CURRENT-BALANCE": "0.0",
                        "TOTAL-OTHER-INSTALLMENT-AMT": "0",
                        "TOTAL-OTHER-DISBURSED-AMT": "0.0",
                        "TOTAL-OTHER-OVERDUE-AMT": "0.0",
                    },
                    "ADDITIONAL-SUMMARY": [],
                    "PERFORM-ATTRIBUTES": []
                },
                "TRENDS": {
                    "NAME": "SCORE-HISTORY",
                    "DATES": "31-12-2025|30-09-2025|30-06-2025|31-03-2025|31-12-2024|30-09-2024|30-06-2024|31-03-2024|31-12-2023|30-09-2023|30-06-2023|31-03-2023",
                    "VALUES": "698|691|698|686|686|686|686|657|657|649|649|649",
                    "RESERVED1": "Perform Consumer v2",
                    "RESERVED2": null,
                    "RESERVED3": null,
                    "DESCRIPTION": "|||||||||||"
                },
                "ALERTS": []
            }
        }
    }
}); // Put null i no
  const [Equifaxv2Error, setEquifaxv2Error] = useState(null); // Put Null if no
  const [submittedName, setSubmittedName] = useState("");
  const [submittedMobile, setSubmittedMobile] = useState("");
  const [showLoader, setShowLoader] = useState(false);
  const [isModalOpenMobile, setIsModalOpenMobile] = useState(false);
  const [mobileResponseData, setMobileResponseData] = useState(null);
  const [afterVerifyMobPan, setAfterVerifyMobPan] = useState("");
  const [afterVerifyMobAadhar, setAfterVerifyMobAadhaar] = useState("");
  const [afterMobName, setAfterMobName] = useState("");
  const [triggerVerifyContine, setTriggerVerifyContinue] = useState("");
  const [isDownloading, setIsDownloading] = useState(false);
  const [isVerifyDisabled, setIsVerifyDisabled] = useState(
    sessionStorage.getItem("verifyClicked") === "true",
  );

  const maxScore = 900;
  const validateForm = () => {
    const newErrors = {};

    if (!firstName.trim()) {
      newErrors.firstName = "First Name is required.";
    }

    if (!lastName.trim()) {
      newErrors.lastName = "Last Name is required.";
    }

    // Validate mobile
    if (mobile === "") {
      newErrors.mobile = "Mobile number is required.";
    } else if (!/^[6-9]\d{9}$/.test(mobile)) {
      newErrors.mobile = "Enter a valid 10-digit mobile number.";
    }

    if (panNo === "") {
      newErrors.panNo = "PAN number is required.";
    } else if (!/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(panNo.toUpperCase().trim())) {
      newErrors.panNo = "Enter a valid PAN number (e.g., ABCDE1234F).";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handlesubmit = async () => {
    try {
      // Validate the form first
      const isValid = validateForm();
      if (!isValid) {
        setEquifaxv2Report(null);
        setEquifaxv2Error(null);
        return;
      }
      setShowLoader(true);
      await GetCrifCreditScore();

      setTimeout(() => {
        setShowLoader(false);
      }, 2000);
    } catch (error) {
      console.error("Error submitting data:", error);
      showErrorToast("Validate the Required Field");
      setShowLoader(false);
    }
  };

  const handleDownloadPDF = () => {
    setIsDownloading(true);
    setTimeout(() => {
      const element = document.getElementById("CreditReport");

      if (element) {
        element.classList.remove("hidden");
        const clonedElement = element.cloneNode(true);
        clonedElement.style.maxHeight = "none";
        clonedElement.style.overflow = "visible";
        const tempDiv = document.createElement("div");
        tempDiv.style.position = "absolute";
        tempDiv.style.visibility = "hidden";
        tempDiv.appendChild(clonedElement);
        document.body.appendChild(tempDiv);
        html2pdf()
          .from(clonedElement)
          .set({
            margin: [0.2, 0.2, 0.2, 0.2],
            filename: "Crif Credit Report.pdf",
            image: { type: "jpeg", quality: 0.9 },
            html2canvas: { scale: 2, backgroundColor: "white" },
            jsPDF: { unit: "in", format: "letter", orientation: "portrait" },
          })
          .save()
          .then(() => {
            document.body.removeChild(tempDiv);
            element.classList.add("hidden");
            setIsDownloading(false); //  Stop loading
          })
          .catch(() => {
            showErrorToast("Failed to generate PDF");
            element.classList.add("hidden");
            setIsDownloading(false); //  Stop loading
          });
      } else {
        showErrorToast("No data found to download");
      }
    }, 500);
  };

  async function GetCrifCreditScore() {
    try {
      setShowLoader(true);
      const payload = {
        api_id: profileData?.user_id,
        api_key: profileData?.api_key,
        token_id: profileData?.token_id,
        mobile: mobile,
        pan: panNo,
        first_name: firstName,
        last_name: lastName,
        consent: "Y",
      };
      const response = await checkCrifCreditScore(payload);
      //  console.log("crif vvv11", response);
      const statusCode = response?.status?.code || response?.status;

      if (
        statusCode === 403 &&
        statusCode.message === "Invalid or deactivated API key."
      ) {
        setShowLoader(false);
        setIsLoading(false);
        showErrorToast("Invalid or deactivated API key.");
        return;
      }

      if (
        statusCode === 422 &&
        statusCode.message === "Insufficient balance in wallet."
      ) {
        setShowLoader(false);
        setIsLoading(false);
        showErrorToast("Insufficient balance.");
        return;
      }

      if (
        statusCode === 422 &&
        statusCode.message ===
          "Your service is not available in this environment."
      ) {
        setShowLoader(false);
        setIsLoading(false);
        showErrorToast("Your service is not available in this environment.");
        return;
      }

      if (
        statusCode === 422 &&
        statusCode.message === "User not authorized to access this service."
      ) {
        setShowLoader(false);
        setIsLoading(false);
        showErrorToast("User not authorized to access this service.");
        return;
      }
      console.log("res" ,response?.data?.report_data?.crifData?.SCORES?.SCORE?.['SCORE-VALUE'] || 0);

      if (statusCode === 200) {
        //  Success

        

        setEquifaxv2Report(response || response?.data);
        setCreditScore(
          Number(
            response?.data?.report_data?.crifData?.SCORES?.SCORE?.['SCORE-VALUE'] || 0,
          ),
        );
        setSubmittedName(cusName);
        setCusName("");
        setMobile("");
        setPanNo("");
        showSuccessToast(
          response?.credit_report_message?.message ||
            response?.message ||
            "Credit score fetched successfully.",
        );
      } else {
        //  All other errors
        setEquifaxv2Error(response?.error || response?.data || {}); // Now capturing error block
        setEquifaxv2Report(null);
        // setModalOpen(true);
        showErrorToast(
          response?.data?.message || // Fallback message in response.data
            response?.message || // Type 1 error (top-level message)
            response?.data?.error?.credit_report_message?.message || // Type 2 error
            response?.data?.error || // Direct string error like "Insufficient balance.
            "Something went wrong.", // Default fallback
        );
      }
    } catch (error) {
      console.error("Error in Crif Score:", error);
      setEquifaxv2Report(null);
      setEquifaxv2Error(error);
      showErrorToast("Something went wrong.");
    } finally {
      setShowLoader(false);
      setIsLoading(false);
    }
  }

  useEffect(() => {
    async function fetchProfileData() {
      try {
        const response = await fetchProfile();
        setProfileData(response.data);
      } catch (error) {
        console.error("Error fetching profile data", error);
      }
    }
    fetchProfileData();
  }, []);

  const handleVerifyMobile = async () => {
    const newErrors = {};

    // Only validate mobile
    if (!mobile.trim()) {
      newErrors.mobile = "Mobile is required";
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    try {
      setShowLoader(true);
      setIsVerifyDisabled(true);
      sessionStorage.setItem("verifyClicked", "true");

      const payload = {
        api_id: profileData?.user_id,
        api_key: profileData?.api_key,
        token_id: profileData?.token_id,
        mobile_number: mobile,
        first_name: firstName,
        last_name: lastName,
      };

      const response = await V2VerifyMobile(payload);

      if (
        response.status === 403 &&
        response.data.message === "Invalid or deactivated API key."
      ) {
        setShowLoader(false);
        setIsLoading(false);
        showErrorToast("Invalid or deactivated API key.");
        return;
      }

      if (
        response.status === 422 &&
        response.data.message === "Insufficient balance in wallet."
      ) {
        setShowLoader(false);
        setIsLoading(false);
        showErrorToast("Insufficient balance in wallet.");
        return;
      }

      if (
        response.status === 422 &&
        response.data.message === "User not authorized to access this service."
      ) {
        setShowLoader(false);
        setIsLoading(false);
        showErrorToast("User not authorized to access this service.");

        return;
      }

      setMobileResponseData(response || response?.data || response?.data?.data);
      if (response?.data?.result !== null) {
        showSuccessToast(
          response?.status?.message ||
            response?.message ||
            "Consumer Details Fetched",
        );
      } else {
        showErrorToast(
          response?.status?.message || response?.message || "No Records Found",
        );
      }

      setShowLoader(false);
      setIsLoading(false);
      setIsModalOpenMobile(true);
      setIsVerifyDisabled(false);
    } catch (error) {
      console.error("Error verifying Consumer:", error);
      setIsVerifyDisabled(false);
      setShowLoader(false);
      setIsLoading(false);
    }
  };

  // Reset on page load
  useEffect(() => {
    sessionStorage.removeItem("verifyClicked");
  }, []);

  const VerifyContinue = () => {
    setTriggerVerifyContinue(true);
    setIsModalOpenMobile(false);
  };

  useEffect(() => {
    if (triggerVerifyContine) {
      // Priority: PAN first, then Aadhaar
      if (afterVerifyMobPan && !afterVerifyMobPan.startsWith("XXXX")) {
        setDocType("pan");
        setPanNo(afterVerifyMobPan);
      } else if (
        afterVerifyMobAadhar &&
        !afterVerifyMobAadhar.startsWith("XXXX")
      ) {
        setDocType("aadhaar");
        setPanNo(afterVerifyMobAadhar);
      }

      if (afterMobName) {
        const name = afterMobName || "";
        const nameParts = name.trim().split(" ");
        const firstNameFromName = nameParts[0] || "";
        const lastNameFromName =
          nameParts.length > 1 ? nameParts.slice(1).join(" ") : "";

        setFirstName(firstNameFromName);
        setLastName(lastNameFromName);

        //  setCusName(afterMobName);
      }

      // Reset trigger
      setTriggerVerifyContinue(false);
    }
  }, [
    triggerVerifyContine,
    afterVerifyMobPan,
    afterVerifyMobAadhar,
    afterMobName,
  ]);

  const accSummary =
    Equifaxv2Report?.report_data?.crifData?.["ACCOUNTS-SUMMARY"] ||
    Equifaxv2Report?.data?.report_data?.crifData?.["ACCOUNTS-SUMMARY"] ||
    Equifaxv2Report?.data?.credit_report?.["ACCOUNTS-SUMMARY"] ||
    {};
  const primary = accSummary["PRIMARY-ACCOUNTS-SUMMARY"] || {};
  const derived = accSummary["DERIVED-ATTRIBUTES"] || {};

  return (
    <>
      <Seo />
      {showLoader && <Loader />}

      <Header heading="Crif Credit Score" />
      <DivTag className="container grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 p-4 bg-white mt-2 shadow-md rounded-md">
        {/* Mobile */}

        <DivTag className="flex flex-col">
          <HeadTag className="text-md font-serif mb-1">
            First Name<strong className="text-red-700">*</strong>
          </HeadTag>
          <input
            type="text"
            id="first_name"
            name="first_name"
            value={firstName}
            className="p-1 rounded shadow-lg shadow-blue-500/50 border border-blue-600 w-full required"
            placeholder="Enter First Name"
            onChange={(e) => {
              setFirstName(e.target.value);
              setErrors((prev) => ({ ...prev, firstName: "" }));
            }}
          />
          {errors.firstName && (
            <p className="text-red-600 text-sm font-mono mt-1">
              {errors.firstName}
            </p>
          )}
        </DivTag>

        <DivTag className="flex flex-col">
          <HeadTag className="text-md font-serif mb-1">
            Last Name<strong className="text-red-700">*</strong>
          </HeadTag>
          <input
            type="text"
            id="last_name"
            name="last_name"
            value={lastName}
            className="p-1 rounded shadow-lg shadow-blue-500/50 border required border-blue-600 w-full"
            placeholder="Enter Last Name"
            onChange={(e) => {
              setLastName(e.target.value);
              setErrors((prev) => ({ ...prev, lastName: "" }));
            }}
          />
          {errors.lastName && (
            <p className="text-red-600 text-sm font-mono mt-1">
              {errors.lastName}
            </p>
          )}
        </DivTag>

        <DivTag className="flex flex-col">
          <div className="flex items-center justify-between mb-1">
            <HeadTag className="text-md font-serif">
              Mobile <strong className="text-red-700">*</strong>
            </HeadTag>

            {/* Small Button beside label */}
            {/* <button
                            type="button"
                            onClick={() => setIsModalOpenMobile(true)}
                            className="text-sm bg-green-600 text-white px-1 rounded hover:bg-green-700"
                        >
                            View

                        </button> */}
          </div>

          {/* Input + Button */}
          <div className="flex">
            <InputField
              type="text"
              placeholder="Enter Mobile"
              className="p-1 rounded shadow-lg shadow-blue-500/50 border border-blue-600 w-full"
              name="mobile"
              id="mobile"
              onChange={(e) => setMobile(e.target.value)}
            />
            {/* <button
                            type="button"
                            onClick={handleVerifyMobile}
                            disabled={isVerifyDisabled}
                            className={`bg-blue-600 text-white p-1 hover:bg-blue-700 ${isVerifyDisabled ? 'opacity-50 cursor-not-allowed' : ''}`}
                        >
                            Verify
                        </button> */}
          </div>

          {errors.mobile && (
            <p className="text-red-600 text-sm font-mono mt-1">
              {errors.mobile}
            </p>
          )}

          {/* Modal */}
          {isModalOpenMobile && (
            <MobileDataModal
              setAfterMobName={setAfterMobName}
              mobileResponseData={mobileResponseData}
              setAfterVerifyMobPan={setAfterVerifyMobPan}
              setAfterVerifyMobAadhaar={setAfterVerifyMobAadhaar}
              VerifyContinue={VerifyContinue}
              onClose={() => setIsModalOpenMobile(false)}
            />
          )}
        </DivTag>

        {/* Doc No. */}
        <DivTag className="flex flex-col">
          <HeadTag className="text-md font-serif mb-1">
            {docType === "pan"
              ? "Pan No."
              : docType === "aadhaar"
                ? "Aadhar No."
                : "Pan."}
            <strong className="text-red-700">*</strong>
          </HeadTag>

          <InputField
            type="text"
            placeholder={
              docType === "pan"
                ? "Enter Pan"
                : docType === "aadhaar"
                  ? "Enter Aadhar"
                  : "Enter Doc No."
            }
            className="p-1 rounded shadow-lg shadow-blue-500/50 border border-blue-600 w-full"
            name="pan_no"
            id="pan_no"
            value={panNo}
            onChange={(e) => setPanNo(e.target.value)}
            disabled={!docType} // Optional: disable if no DocType selected
          />
          {errors.panNo && (
            <p className="text-red-600 text-sm font-mono mt-1">
              {errors.panNo}
            </p>
          )}
        </DivTag>
      </DivTag>
      <div className="flex justify-center">
        <button
          className={`rounded-md p-1 bg-blue-700 text-white mt-4 mb-1 h-8 px-3 ${isLoading ? "opacity-50 cursor-not-allowed" : ""}`}
          onClick={handlesubmit}
          disabled={isLoading}
        >
          {isLoading ? "Submitting..." : "Get Credit Report"}
        </button>
      </div>

      <div className="w-full text-center">
        {errors.identification && (
          <p className="text-red-600 text-sm font-mono">
            {errors.identification}
          </p>
        )}
      </div>

      {Equifaxv2Report || Equifaxv2Error ? (
        <div class="flex flex-col p-4 bg-white shadow-inner md:mt-1 shadow-blue-600 rounded-md">
          <span className="text-center font-bold md:text-xl">
            Hey{" "}
            {Equifaxv2Report?.report_data?.REQUEST?.NAME ||
            Equifaxv2Report?.credit_report?.REQUEST?.NAME
              ? Equifaxv2Report.report_data.REQUEST.NAME
              : Equifaxv2Error?.first_name ||
                Equifaxv2Error?.error?.first_name ||
                "N/A"}
            !
          </span>

          <h2 class="text-xl md:text-xl font-semibold text-center">
            Your Credit Score
          </h2>

          <div class="flex flex-col md:flex-row justify-center md:justify-center gap-4 md:gap-8 md:mt-2 mt-3 relative">
            <div class="w-full md:w-[400px] relative md:mt-10">
              <span
                class="text-red-500 md:font-bold absolute md:top-[20px] md:left-10 md:mt-16 -rotate-70
    top-[60px] left-5 
    "
              >
                Poor
              </span>
              <span
                class="text-yellow-400 md:font-bold absolute md:left-[104px] md:mt-1 -rotate-26
    left-[69px] top-[-7px] 
    "
              >
                Average
              </span>
              <span
                class="text-orange-600 md:font-bold absolute md:left-60 md:mt-0 md:rotate-20
    left-[12rem] mt-[-9px] rotate-20
    "
              >
                Good
              </span>
              <span
                class="text-green-800 md:font-bold absolute md:top-[20px] md:ml-[19.5rem] md:mt-16 rotate-70
    ml-[16rem] mt-[3.5rem]
    "
              >
                Excellent
              </span>

              <GaugeChart
                id="gauge-chart1"
                nrOfLevels={3}
                percent={creditScore / maxScore} // Normalized value for gauge
                needleColor={"#00008b"}
                textColor={"transparent"} // Hides the percentage text
                needleBaseColor={"red"}
                arcsLength={[0.3, 0.3, 0.3, 0.3]}
                colors={["#cc0000", "#e6e600", "#cc6600", "#009900"]}
              />
              <p
                class="text-black font-bold text-xl md:text-2xl absolute bottom-12  md:bottom-[5.5rem] 
                    left-1/2 transform -translate-x-1/2"
              >
                {creditScore}
              </p>
            </div>

            <div class="flex flex-col items-center md:items-start">
              <div className="text-center font-bold md:text-xl">
                <ul className="text-left text-sm md:text-base space-y-1 mt-4">
                  <li>
                    <span className="font-bold">No of Accounts: </span>
                    {primary["PRIMARY-NUMBER-OF-ACCOUNTS"] || "0"}
                  </li>
                  <li>
                    <span className="font-bold">Active Accounts: </span>
                    {primary["PRIMARY-ACTIVE-NUMBER-OF-ACCOUNTS"] || "0"}
                  </li>
                  <li>
                    <span className="font-bold">Total Balance Amount: </span>
                    {primary["PRIMARY-CURRENT-BALANCE"] || "0"}
                  </li>
                  <li>
                    <span className="font-bold">Total Past Due: </span>
                    {primary["PRIMARY-OVERDUE-NUMBER-OF-ACCOUNTS"] || "0"}
                  </li>
                  <li>
                    <span className="font-bold">
                      Recent Accounts (last 6m):{" "}
                    </span>
                    {derived["NEW-ACCOUNTS-IN-LAST-SIX-MONTHS"] || "0"}
                  </li>
                  <li>
                    <span className="font-bold">New Delinq (last 6m): </span>
                    {derived["NEW-DELINQ-ACCOUNT-IN-LAST-SIX-MONTHS"] || "0"}
                  </li>
                </ul>
              </div>

              <CrifScoreReportModal
                isOpen={isModalOpen}
                onClose={() => setModalOpen(false)}
                Equifaxv2Report={Equifaxv2Report}
                Equifaxv2Error={Equifaxv2Error}
                submittedName={submittedName}
                submittedMobile={submittedMobile}
              />
              <div class="flex space-x-2 mt-4">
                <button
                  onClick={() => setModalOpen(true)}
                  class="bg-blue-600 text-white text-sm md:text-base rounded-md px-2 py-1"
                >
                  View
                </button>
                {/* <button
                                        className="bg-red-600 text-white text-sm md:text-base rounded-md px-2 py-1"
                                        onClick={handleDownloadPDF}
                                        disabled={isDownloading}
                                    >
                                        {isDownloading ? "Downloading..." : "Download"}
                                    </button> */}
              </div>
            </div>
          </div>
        </div>
      ) : (
        ""
      )}
      <div className="flex justify-center">
        <div class="flex flex-col items-center bg-gray-200 rounded-md shadow-lg shadow-blue-800 md:w-3/4 w-full p-1">
          <h1 class="font-bold text-2xl text-red-600 underline mb-2">
            Instructions
          </h1>
          <h2 class="text-xl font-bold text-center text-gray-800 mb-2 underline">
            How to get Best Financial Credit Report in Crif?
          </h2>

          <ul class="list-decimal list-inside text-left text-gray-700">
            <li className="">
              Enter the correct customer’s First name and Last Name.
            </li>
            <li>
              Enter the Mobile Number which is registered in credit bureau
              company.
            </li>
            <li>Enter the correct PAN Number.</li>
            <li>
              The Crif Credit Report only provide the details Report of that
              consumer which is available in the Crif Bureau.
            </li>
            <li>
              If you didn’t get the report means you should try with different
              details or in another bureau company.
            </li>
          </ul>
        </div>
      </div>
    </>
  );
};

export default CrifCreditScore;

const MobileDataModal = ({
  mobileResponseData,
  onClose,
  setAfterVerifyMobPan,
  setAfterVerifyMobAadhaar,
  setAfterMobName,
  VerifyContinue,
}) => {
  const rootData = mobileResponseData?.data || {};

  setAfterMobName(rootData?.name);
  setAfterVerifyMobPan(rootData?.pan);
  setAfterVerifyMobAadhaar(rootData?.aadhaar || "");

  const addresses = rootData?.address || [];

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white p-3 rounded-lg shadow-2xl w-[90%] max-w-3xl max-h-[95vh] overflow-y-auto space-y-1">
        <div className="flex justify-between">
          <h2 className="text-2xl font-bold text-blue-700 border-b">
            Consumer Verification Details
          </h2>
          <button
            onClick={onClose}
            className="text-2xl text-red-600 hover:text-red-800"
          >
            ❌
          </button>
        </div>

        {rootData?.name && (
          <div className="w-full flex flex-col items-center mb-2">
            <h3 className="text-xl text-green-600 font-semibold text-center">
              Found In Experian
            </h3>
            <Link
              to="/ExperianScore2"
              className="flex items-center bg-green-700 hover:bg-green-800 text-white font-semibold py-2 px-4 gap-2 rounded transition duration-300 text-sm sm:text-base"
            >
              Result Found in Experian, Check Credit details in Experian for
              better result
              <FaHandPointLeft className="text-lg" />
            </Link>
          </div>
        )}

        {rootData?.idspay_message && (
          <div
            className={`flex justify-center border-2 p-3 rounded-lg ${
              rootData.idspay_message === "success"
                ? "bg-green-100 border-green-300"
                : "bg-red-100 border-red-300"
            }`}
          >
            <p
              className={`text-md font-serif ${
                rootData.idspay_message === "success"
                  ? "text-green-600"
                  : "text-red-500"
              }`}
            >
              {rootData.idspay_message}
            </p>
          </div>
        )}

        {/* Personal Info */}
        <div className="bg-blue-50 p-2 rounded-md shadow">
          <h3 className="text-lg font-semibold text-blue-600 mb-1">
            Personal Info
          </h3>
          <div className="grid grid-cols-2 gap-1 text-sm">
            <p>
              <strong>Full Name:</strong> {rootData?.name || "N/A"}
            </p>

            <p>
              <strong>DOB:</strong> {rootData?.dob || "N/A"}
            </p>
            <p>
              <strong>Gender:</strong> {rootData?.gender || "N/A"}
            </p>
            <p>
              <strong>PAN:</strong> {rootData?.pan || "N/A"}
            </p>
            <p>
              <strong>Email:</strong> {rootData?.email || "N/A"}
            </p>
          </div>
        </div>

        {/* Addresses */}
        <div className="bg-yellow-50 p-2 rounded-md shadow">
          <h3 className="text-lg font-semibold text-yellow-600 mb-2">
            Addresses
          </h3>
          {addresses.length > 0 ? (
            <div className="overflow-x-auto">
              <table className="w-full text-sm border border-gray-300 rounded-md">
                <thead className="bg-yellow-100 text-gray-700">
                  <tr>
                    <th className="border px-2 py-1 text-left">Address #</th>
                    <th className="border px-2 py-1 text-left">Full Address</th>
                    <th className="border px-2 py-1 text-left">State</th>
                    <th className="border px-2 py-1 text-left">Postal Code</th>
                  </tr>
                </thead>
                <tbody>
                  {addresses.map((address, index) => (
                    <tr key={index} className="border-t">
                      <td className="border px-2 py-1">Address {index + 1}</td>
                      <td className="border px-2 py-1">
                        {[
                          address.first_line_of_address,
                          address.second_line_of_address,
                          address.third_line_of_address,
                        ]
                          .filter(Boolean)
                          .join(", ")}
                      </td>
                      <td className="border px-2 py-1">
                        {address.state || "N/A"}
                      </td>
                      <td className="border px-2 py-1">
                        {address.postal_code || "N/A"}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <p className="text-sm">No address information available.</p>
          )}
        </div>

        {/* Footer Buttons */}
        <div className="flex justify-center gap-3 mt-3">
          <button
            onClick={VerifyContinue}
            className="bg-green-500 text-white px-4 py-1 rounded-md hover:bg-green-600 transition"
          >
            Verify & Continue
          </button>
          <button
            onClick={onClose}
            className="bg-red-500 text-white px-4 py-1 rounded-md hover:bg-red-600 transition"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};
